var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters } from 'vuex';
import { LOCATION, FRANCHISOR } from '@/stores/defs';
import localStorageAdapter from '@/utils/LocalStorageAdapter';
import customerService from '@Service/customer.service';
import accountMixin from '@Mixin/accountMixin';
import navigationMixin from '@Mixin/navigationMixin';
import recentOrdersMixin from '@Mixin/recentOrdersMixin';
import allService from '@Service/all.service'; // TODO make customer specific endpoint
var loginMixin = {
    mixins: [
        accountMixin,
        navigationMixin,
        recentOrdersMixin,
    ],
    computed: __assign({}, mapGetters({
        location: LOCATION.GET_LOCATION,
        franchisor: FRANCHISOR.GET_FRANCHISOR,
    })),
    data: function () {
        return {
            pin: '',
            phone: '',
        };
    },
    methods: {
        getLoginLocation: function () {
            var location = this.location;
            if (location.id) {
                return location.id;
            }
            var franchisor = this.franchisor;
            return franchisor.id;
        },
        getLoginPhone: function () {
            var phone = this.userPhone;
            return phone;
        },
        getToken: function () {
            return this.pin;
        },
        getBaseQuery: function () {
            var location = this.getLoginLocation();
            var phone = this.getLoginPhone();
            var query = {
                lb: location,
                phone: phone,
            };
            return query;
        },
        sendLoginRequest: function () {
            var loginQuery = this.getBaseQuery();
            loginQuery['cmd'] = 'generate_token';
            return customerService.login(loginQuery);
        },
        sendTokenRequest: function () {
            var tokenQuery = this.getBaseQuery();
            tokenQuery['token'] = this.getToken();
            tokenQuery['cmd'] = 'verify_token';
            return customerService.login(tokenQuery);
        },
        setCustomerLoggedIn: function (raw) {
            var _this = this;
            var customer = customerService.getCustomerOnLogin(raw);
            this.setCustomer(customer);
            this.setLoggedIn(true);
            // TODO add option to persist or not (check keep me logged in)
            // default is to persist for now
            localStorageAdapter.setCustomerBase(customer.id);
            customerService.setCustomerForStorage(customer);
            allService.load(function (_a) {
                var recentOrders = _a.recentOrders;
                _this._setRecentOrders(recentOrders);
            }, this.location.id);
        },
        parseInitialResponse: function (response) {
            var data = response.data || { body: null };
            var message = data.message || 'error';
            var body = data.body;
            return {
                message: message,
                body: body,
            };
        },
        initialSignUpSuccess: function (response) {
            var _a = this.parseInitialResponse(response), message = _a.message, body = _a.body;
            if (body) {
                // TODO 'new_acount' needs to change (requires server and client update)
                // ^ could potentially serve both until all versions are caught up.
                var newAccount = body.new_acount;
            }
            if (message === 'Successfully sent PIN') {
                this._navigateToPin();
                return;
            }
        },
        initialLoginSuccess: function (response) {
            var _a = this.parseInitialResponse(response), message = _a.message, body = _a.body;
            if (message === 'Successfully sent PIN') {
                this._navigateToPin();
                return;
            }
            return; // TODO handle error states
        },
    },
    mounted: function () {
        this.phone = this.guestPhone;
    }
};
export default loginMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/loginMixin.ts
// module id = yKfu
// module chunks = 18